import Split from './Split'

export default Split
